


















import Vue from "vue";
// import ProjectsList from "@/components/ProjectsList.vue";
import gameProjectsData from "@/data/GameProjectsData.ts";

export default Vue.extend({
  name: "GameProjects",
  components: {
    // ProjectsList,
  },
  data: function () {
    return {
      projects: gameProjectsData,
    };
  },
});
